var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hr',{staticClass:"v-divider theme--dark",style:({margin: ("0 0 0 " + _vm.inset + "px")})})}
var staticRenderFns = []

export { render, staticRenderFns }